import { EARN } from './earn';
import { REDEEM } from './redeem';

export const REWARDS = { EARN, REDEEM };
